<template>
  <v-card-text>
    <div class="mb-3 d-flex justify-space-between subtitle-1 lighttext--text">
      <span>{{ sectionTitle }}</span>
      <span
        :class="complete ? 'success--text' : 'lighttext--text'"
        v-if="showComplete"
      >
        <v-icon class="mr-2" :color="complete ? 'success' : 'lighttext'"
          >check_circle</v-icon
        >
        {{ complete ? "Complete" : "Incomplete" }}
      </span>
    </div>
    <div class="text-h6 font-weight-medium">
      {{ question }}
    </div>
  </v-card-text>
</template>

<script>
export default {
  name: "AnnualReviewQuestionHeader",
  props: {
    complete: { type: Boolean, default: false },
    sectionTitle: { type: String },
    question: { type: String },
    showComplete: { type: Boolean, default: false }
  }
};
</script>
